/**
 * Соответствие доменных кодов иконкам.
 *
 * Плитки дня и категории расходов приходят из БД, и приходят они **кодом**
 * (`pickup`, `walk`, `food`), а не эмодзи. Эмодзи в `event_types.emoji`
 * остаётся: он нужен уведомлениям бота, где картинку не показать.
 *
 * Своя плитка семьи кода из справочника не имеет — для неё запасной значок.
 */

import type { ExpenseCategory } from '@/shared/api/day'
import type { TaskKind } from '@/shared/api/schedule'
import type { IconName } from '@/shared/ui/icon-names'

const EVENT_ICONS: Record<string, IconName> = {
  pickup: 'ev-pickup',
  walk: 'ev-walk',
  meal: 'ev-meal',
  nap: 'ev-nap',
  activity: 'ev-activity',
  lesson: 'ev-lesson',
  bath: 'ev-bath',
  medicine: 'ev-medicine',
  dropoff: 'ev-dropoff',
  note: 'ev-note',
  here: 'ev-here',
}

/** Иконка типа события по его коду. Своя плитка семьи получает искорку. */
export function eventIcon(code: string | null | undefined): IconName {
  return (code && EVENT_ICONS[code]) || 'ev-custom'
}

/**
 * Есть ли у этого кода иконка из набора.
 *
 * Семья заводит свои плитки сама («Бассейн», «Танцы»), кода в системном
 * справочнике у них нет. Нарисовать им всем одну искорку — значит сделать их
 * неразличимыми, поэтому у своих плиток остаётся эмодзи, выбранный семьёй.
 */
export function hasEventIcon(code: string | null | undefined): boolean {
  return Boolean(code && code in EVENT_ICONS)
}

const EXPENSE_ICONS: Record<ExpenseCategory, IconName> = {
  food: 'exp-food',
  transport: 'exp-transport',
  activity: 'exp-activity',
  pharmacy: 'exp-pharmacy',
  household: 'exp-household',
  other: 'exp-other',
}

export function expenseIcon(category: ExpenseCategory | string | undefined): IconName {
  return EXPENSE_ICONS[category as ExpenseCategory] ?? 'exp-receipt'
}

// Виды задач переиспользуют плитки дня: это одни и те же понятия, и рисовать
// их дважды означало бы завести два значка на один смысл.
const TASK_ICONS: Record<TaskKind, IconName> = {
  pickup: 'ev-pickup',
  meal: 'ev-meal',
  activity: 'ev-activity',
  dropoff: 'ev-dropoff',
  custom: 'task-custom',
}

export function taskIcon(kind: TaskKind | string | undefined): IconName {
  return TASK_ICONS[kind as TaskKind] ?? 'task-custom'
}
